import CryptoJS from "crypto-js";

export const customCryptoPassword = (password) => {
  const passphrase = "mySecretPassphrase";

  const iv = CryptoJS.lib.WordArray.random(16);

  // 將passphrase轉換為16 bytes的key
  const key = CryptoJS.PBKDF2(passphrase, iv, {
    keySize: 128 / 32,
    iterations: 1000,
    /* 明示 SHA1:crypto-js 的 PBKDF2 預設就是 SHA1,不寫也是同樣結果
       (已實測驗證兩者產出的 key 完全相同)。
       寫出來是為了把這個假設鎖住 —— SHA1 已屬弱雜湊,日後若 crypto-js
       改掉預設值,九個站台的密碼加密會一起悄悄變掉且不會有任何錯誤訊息,
       只會表現為登入失敗。與 SDK(cli-integrated-api)的寫法一致。 */
    hasher: CryptoJS.algo.SHA1,
  });

  // 使用CBC模式和PKCS7 padding進行加密
  const ciphertext = CryptoJS.AES.encrypt(password, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // 將iv和ciphertext轉換為Base64格式的字符串
  const ivBase64 = iv.toString(CryptoJS.enc.Base64);
  const ciphertextBase64 = ciphertext.toString();
  return ivBase64 + ":" + ciphertextBase64;
};
